export default "__VITE_ASSET__D7zh2co5__"